/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Importing_ContentsInputs */

const en_importing_contents = /** @type {(inputs: Importing_ContentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importing contents...`)
};

const fr_importing_contents = /** @type {(inputs: Importing_ContentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importation du contenu...`)
};

const de_importing_contents = /** @type {(inputs: Importing_ContentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inhalte werden importiert...`)
};

const it_importing_contents = /** @type {(inputs: Importing_ContentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importazione dei contenuti...`)
};

const ru_importing_contents = /** @type {(inputs: Importing_ContentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Импорт содержимого...`)
};

const es_importing_contents = /** @type {(inputs: Importing_ContentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importando contenidos...`)
};

const zh_cn2_importing_contents = /** @type {(inputs: Importing_ContentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在导入内容……`)
};

const ja_importing_contents = /** @type {(inputs: Importing_ContentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コンテンツをインポートしています...`)
};

const hi_importing_contents = /** @type {(inputs: Importing_ContentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सामग्री आयात की जा रही है...`)
};

const pt_pt2_importing_contents = /** @type {(inputs: Importing_ContentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importando conteúdo...`)
};

/**
* | output |
* | --- |
* | "Importing contents..." |
*
* @param {Importing_ContentsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const importing_contents = /** @type {((inputs?: Importing_ContentsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Importing_ContentsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_importing_contents(inputs)
	if (locale === "de") return de_importing_contents(inputs)
	if (locale === "it") return it_importing_contents(inputs)
	if (locale === "ru") return ru_importing_contents(inputs)
	if (locale === "es") return es_importing_contents(inputs)
	if (locale === "zh-CN") return zh_cn2_importing_contents(inputs)
	if (locale === "ja") return ja_importing_contents(inputs)
	if (locale === "hi") return hi_importing_contents(inputs)
	if (locale === "pt-PT") return pt_pt2_importing_contents(inputs)
	return en_importing_contents(inputs)
});